import { Link, useParams } from "react-router-dom";
import "./boards.scss";
import { BoardType, RootState } from "types";
import { useEffect, useState, useCallback } from "react";
import api, { API_URI, MainDomain } from "api";
import { useDispatch, useSelector } from "react-redux";
import NewBoardModal from "./new-board-modal/new-board-modal";
import { actions } from "redux/reducers";
import { ContextMenu, ContextMenuTrigger, MenuItem } from "react-contextmenu";
import { FaArchive, FaRegCopy } from "react-icons/fa";
import Loader from "components/loader";
import { toast } from "react-toastify";

function Boards({ isArchivedItems }: { isArchivedItems: boolean }) {
    const params: any = useParams();
    const dispatch = useDispatch();
    const state = useSelector((state: RootState) => state);
    const [boards, setBoards] = useState<BoardType[]>([]);
    const [newBoardModalOpen, setNewBoardModalOpen] = useState(false);
    const [loading, setLoading] = useState(true);
    const [boardMenuOpen, setBoardMenuOpen] = useState<boolean>(false);

    if (window.location.href.indexOf("/archived") > -1) {
        isArchivedItems = true;
    }

    const getBoards = useCallback(() => {
        api.board
            .getAll(params.clientId)
            .then((data) => {
                dispatch(actions.boards.set(data));
            })
            .then(() => setLoading(false));
    }, [params.clientId, dispatch]);

    const duplicateBoard = (e: any, data: any) => {
        setLoading(true);
        var boardId = data.boardId;
        let boardName = prompt(`Please enter the New Board Name.\nNote that this will copy all tickets of this board to the new board:`);
        if (boardName) {
            api.board.duplicate(boardId, boardName).then((data) => {
                getBoards();
                if (data) {
                    setTimeout(() => {
                        setLoading(false);
                    }, 3000);
                } else {
                    alert("Error occured duplcating the board/contents.");
                    setLoading(false);
                }
            });
        } else {
            setLoading(false);
        }
    };

    const archiveBoard = (e: any, data: any) => {
        setLoading(true);
        var boardId = data.boardId;
        var boardName = data.boardName;
        let archiveBoard = window.confirm(`Are you sure you want to archive ${boardName}?`);

        if (archiveBoard) {
            api.board
                .archive(boardId)
                .then((data) => {
                    getBoards();
                    if (data) {
                        setTimeout(() => {
                            setLoading(false);
                        }, 3000);
                    }
                })
                .finally(() => setLoading(false));
        } else {
            alert("Error occured archiving the board.");
            setLoading(false);
        }
    };

    const unarchiveBoard = (e: any, data: any) => {
        setLoading(true);
        var boardId = data.boardId;
        var boardName = data.boardName;
        let archiveBoard = window.confirm(`Are you sure you want to archive ${boardName}?`);

        if (archiveBoard) {
            api.board
                .unarchive(boardId)
                .then((data) => {
                    getBoards();
                    if (data) {
                        setTimeout(() => {
                            setLoading(false);
                        }, 3000);
                    }
                })
                .finally(() => setLoading(false));
        } else {
            alert("Error occured archiving the board.");
            setLoading(false);
        }
    };

    const getSalesReport = () => {
        api.report.generateSalesReport(params.clientId);
    };

    useEffect(() => {
        if (isArchivedItems) {
            setBoards(state.boards.filter((x) => x.Board.IsArchived === true));
        } else {
            // setBoards(state.boards);
            setBoards(state.boards.filter((x) => x.Board.IsArchived === false));
        }
    }, [isArchivedItems, state.boards]);

    useEffect(() => {
        getBoards();
    }, [getBoards]);

    return (
        <>
            {!isArchivedItems ? (
                <div id="boards" className="container">
                    <div className="boards-header">
                        Boards
                        <div>
                            <i title="Add New Board" className="fal fa-plus icon" onClick={() => setNewBoardModalOpen(true)}></i>
                            <a href="dashboard/archived">
                                <i title="View Archived Boards" className="fal fa-archive icon"></i>
                            </a>
                            {boards?.some((x) => x.BoardType?.Id > 1) ? (
                                <>
                                    <i
                                        title="options"
                                        className="far fa-ellipsis-h icon"
                                        onClick={(e) => {
                                            setBoardMenuOpen(!boardMenuOpen);
                                        }}
                                    ></i>
                                </>
                            ) : (
                                <></>
                            )}
                            {/* <><i title='options' className="far fa-ellipsis-h icon" onClick={(e) => {
                                        setBoardMenuOpen(!boardMenuOpen);
                                    }}
                                ></i></> */}
                        </div>
                    </div>
                    {boardMenuOpen && (
                        <div className="report-options">
                            <span
                                className="report-button"
                                onClick={() => {
                                    getSalesReport();
                                    setBoardMenuOpen(false);
                                    toast.info("Report has been requested. Please wait until it has been downloaded");
                                }}
                            >
                                Generate sales report
                            </span>
                        </div>
                    )}
                    <div className="boards-container">
                        {boards.map((el: BoardType, i: number) => {
                            const backgroundImage = el.Board.Background ? `https://workflow-api.${MainDomain}.co.za/api/board/${el.Board.Id}/background` : `${process.env.PUBLIC_URL}/img/defaultbg.png`;
                            // const backgroundImage = el.Background ? `https://workflow-api.amasocial.co.za/api/board/${el.Id}/background/${el.Background}` : `${process.env.PUBLIC_URL}/img/defaultbg.png`;

                            return (
                                <>
                                    <ContextMenuTrigger id={`contextmenu${el.Board.Id}`}>
                                        <Link
                                            to={`board/${el.Board.Id}`}
                                            className="board"
                                            key={i}
                                            style={{
                                                color: "#fff",
                                                textShadow: "0 1px 2px rgba(0, 0, 0, 0.4)",
                                            }}
                                        >
                                            <div
                                                style={{
                                                    background: `linear-gradient(rgba(0,0,0,0.3), rgba(0,0,0,0)), url(${backgroundImage}) no-repeat center`,
                                                    flex: "0 1 calc(20% - 14px)",
                                                    height: "100px",
                                                    boxShadow: " 0 1px 3px rgba(0, 0, 0, 0.3)",
                                                    borderRadius: "5px",
                                                    cursor: "pointer",
                                                    transition: "0.2s",
                                                    padding: "10px",
                                                    backgroundSize: "cover",
                                                }}
                                            >
                                                {el.Board.Description}
                                            </div>
                                        </Link>

                                        <ContextMenu id={`contextmenu${el.Board.Id}`}>
                                            <MenuItem data={{ boardId: el.Board.Id }} onClick={duplicateBoard}>
                                                <FaRegCopy style={{ color: "white" }} />
                                                <span>Duplicate Board</span>
                                            </MenuItem>
                                            <MenuItem data={{ boardId: el.Board.Id, boardName: el.Board.Description }} onClick={archiveBoard}>
                                                <FaArchive />
                                                <span>Archive Board</span>
                                            </MenuItem>
                                        </ContextMenu>
                                    </ContextMenuTrigger>
                                </>
                            );
                        })}
                    </div>
                    <Loader show={loading} />
                </div>
            ) : (
                <div id="boards" className="container">
                    <div className="header">
                        Archived Boards
                        <a href="dashboard">
                            <i title="Active Boards" className="fal fa-house"></i>
                        </a>
                    </div>
                    <div className="boards-container">
                        {boards.map((el: BoardType, i: number) => {
                            const backgroundImage = el.Board.Background ? `https://workflow-api.${MainDomain}.co.za/api/board/${el.Board.Id}/background/${el.Board.Background}` : `${process.env.PUBLIC_URL}/img/defaultbg.png`;
                            // const backgroundImage = el.Background ? `https://workflow-api.amasocial.co.za/api/board/${el.Id}/background/${el.Background}` : `${process.env.PUBLIC_URL}/img/defaultbg.png`;

                            return (
                                <>
                                    <ContextMenuTrigger id={`contextmenu${el.Board.Id}`}>
                                        <Link
                                            to={`board/${el.Board.Id}`}
                                            className="board"
                                            key={i}
                                            style={{
                                                color: "#fff",
                                                textShadow: "0 1px 2px rgba(0, 0, 0, 0.4)",
                                            }}
                                        >
                                            <div
                                                style={{
                                                    background: `linear-gradient(rgba(0,0,0,0.3), rgba(0,0,0,0)), url(${backgroundImage}) no-repeat center`,
                                                    flex: "0 1 calc(20% - 14px)",
                                                    height: "100px",
                                                    boxShadow: " 0 1px 3px rgba(0, 0, 0, 0.3)",
                                                    borderRadius: "5px",
                                                    cursor: "pointer",
                                                    transition: "0.2s",
                                                    padding: "10px",
                                                    backgroundSize: "cover",
                                                }}
                                            >
                                                {el.Board.Description}
                                            </div>
                                        </Link>

                                        <ContextMenu id={`contextmenu${el.Board.Id}`}>
                                            {/* <MenuItem data={{ boardId: el.Id }} onClick={duplicateBoard}>
                                                <FaRegCopy className="Copy Board" />
                                                <span>Copy</span>
                                            </MenuItem> */}
                                            <MenuItem data={{ boardId: el.Board.Id, boardName: el.Board.Description }} onClick={unarchiveBoard}>
                                                <FaArchive className="openwith" />
                                                <span>Unarchive Board</span>
                                            </MenuItem>
                                        </ContextMenu>
                                    </ContextMenuTrigger>
                                </>
                            );
                        })}
                    </div>
                    <Loader show={loading} />
                </div>
            )}
            <NewBoardModal id="new-board-modal" open={newBoardModalOpen} setOpen={setNewBoardModalOpen} />
        </>
    );
}

export default Boards;
